/** @jsxImportSource @emotion/react */
import { useTheme } from '@quickbit/qb-design-system';
import { Outlet } from 'react-router-dom';
import { OnboardingProvider, type OnboardingUrls } from 'context/Onboarding';
import { useOnrampData } from 'onramp-pages/context';

const onrampOnboardingUrls: OnboardingUrls = {
  ID_VERIFICATION: '/onramp/login',
  STEPS: '/onramp/onboarding/steps',
  ADDRESS: '/onramp/onboarding/contact-information',
  EMAIL: '/onramp/onboarding/email-verification',
  PASSWORD: '/onramp/onboarding/set-password',
  PHONE: '/onramp/onboarding/phone-verification',
  ONBOARDING: '/onramp/onboarding/kyc',
  SOURCE_OF_FUNDS: '/onramp/onboarding/source-of-funds',
  SUCCESS: '/onramp',
};

export const OnboardingLayout = () => {
  const { breakpoints, spacing, palette, shape } = useTheme();
  const { receiveOrderPreviewId } = useOnrampData();
  return (
    <OnboardingProvider
      urls={onrampOnboardingUrls}
      receiveOrderPreviewId={receiveOrderPreviewId}
    >
      <div
        css={{
          height: '100%',
          [breakpoints.laptopSmall]: {
            header: {
              padding: `${spacing.xxxs} 0`,
              div: {
                display: 'flex',
                justifyContent: 'center',
              },
            },
            background: palette.white,
            borderRadius: `calc(${shape.borderRadius} * 2)`,
            padding: spacing.s,
            paddingTop: spacing.xs,
            paddingBottom: 0,
          },
        }}
      >
        <Outlet />
      </div>
    </OnboardingProvider>
  );
};

export default OnboardingLayout;
